import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (pathname === "/") return null;

  const goBack = () => {
    if (window.history.length > 2) navigate(-1);
    else navigate("/");
  };

  return (
    <button
      onClick={goBack}
      data-testid="back-button"
      aria-label="Torna alla pagina precedente"
      className="fixed bottom-5 left-5 z-[120] group inline-flex items-center gap-2 bg-foreground text-background pl-3 pr-4 py-3 shadow-lg hover:bg-primary transition-colors"
    >
      <ArrowLeft className="w-5 h-5 group-hover:-translate-x-0.5 transition-transform" />
      <span className="font-mono text-xs uppercase tracking-widest">Indietro</span>
    </button>
  );
}
